import { useEffect, useState } from "react";

export const useFanpageMenuState = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isFanpageMenuOpen, setIsFanpageMenuOpen] = useState(true);

  const handleToggleFanpageMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    const willOpen = !isFanpageMenuOpen;
    setIsFanpageMenuOpen(willOpen);
    if (willOpen) {
      setIsSidebarOpen(false);
    }
  };

  const handleToggleUserSidebar = () => {
    const willOpen = !isSidebarOpen;
    setIsSidebarOpen(willOpen);
    if (willOpen) {
      setIsFanpageMenuOpen(false);
    } else {
      setIsFanpageMenuOpen(true);
    }
  };

  const openFanpageMenu = () => {
    setIsFanpageMenuOpen(true);
    setIsSidebarOpen(false);
  };

  useEffect(() => {
    if (window.innerWidth < 1024) {
      setIsFanpageMenuOpen(false);
    }

    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsFanpageMenuOpen((prev) => {
          if (prev) {
            return false;
          }
          return prev;
        });
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    isSidebarOpen,
    isFanpageMenuOpen,
    handleToggleFanpageMenu,
    handleToggleUserSidebar,
    openFanpageMenu,
  };
};
